module.exports = __webpack_public_path__ + "static/img/deal1.34dd409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/deal1.jpg
// module id = DM+Z
// module chunks = 1